import {Component, EventEmitter, Input, Output} from "@angular/core";
import {ServiceLocation} from "../../models/service-location";

@Component({
  selector: "marker-modal",
  templateUrl: "./marker-modal.component.html",
})
export class MarkerModalComponent {

  @Input() public location: ServiceLocation;
  @Input() public show: boolean;
  @Output() public doAction = new EventEmitter();

  public delete() {
    this.doAction.emit("delete");
    this.show = false;
  }

  public save() {
    this.doAction.emit("save");
    this.show = false;
  }

  public cancel() {
    this.doAction.emit("cancel");
    this.show = false;
  }

}
